function getMetaTagValue(tagName) {
  const element = document.querySelector(`meta[name='${tagName}']`);
  return element == null ? void 0 : element.getAttribute("content");
}
const PAGE_BRAND = getMetaTagValue("page-brand");
const PAGE_COUNTRY = getMetaTagValue("page-country");
const PAGE_COUNTRY_TITLE = getMetaTagValue("page-country-title");
const PAGE_LANGUAGE = getMetaTagValue("page-language");
const PAGE_SKIN = getMetaTagValue("page-skin");
const PAGE_MARKET = `${PAGE_LANGUAGE}-${PAGE_COUNTRY}`;
const PAGE_COUNTRY_PHONE_CODE = getMetaTagValue("page-country-phone-code");
const PAGE_CONTEXT = `${PAGE_BRAND}/${PAGE_COUNTRY}`;
const ACCESSORY_ASSETS_SOURCE_PATH_LOGIC_VALUES = {
  MOPAR: "mopar",
  BRAND: "brand"
};
const BRAND_DAM_PATH = `/content/dam/${PAGE_BRAND}/`;
const MOPAR_DAM_PATH = getMetaTagValue("mopar-dam-path");
const BRAND_MOPAR_DAM_PATH = `/content/dam/${PAGE_BRAND}/mopar/`;
const BRAND_PATH = `/content/${PAGE_BRAND}/`;
const MOPAR_PATH = `/content/mopar/`;
const ACCESSORY_ASSETS_PATH = getMetaTagValue("accessory-assets-source-path");
const ACCESSORY_ASSETS_BRAND_PATH = `${BRAND_MOPAR_DAM_PATH}accessories`;
const ACCESSORY_ASSETS_MOPAR_PATH = `${getMetaTagValue("mopar-dam-path")}accessories`;
const FALLBACK_CAR_IMAGE = `${BRAND_DAM_PATH}products/fallback-car.png`;
const ANCHOR_ANIMATION_DELAY = 1e3;
const ANCHOR_ANIMATION_OFFSET_TOP = 100;
const IMAGE_360_MODE = {
  CONTAIN: "contain",
  COVER: "cover"
};
const RENDITIONS_PATH = ".thumb.1280.1280.png";
const RENDITIONS_SIZE = {
  SMALL: ".thumb.48.48.png",
  MEDIUM: ".thumb.140.100.png",
  LARGE: ".thumb.319.319.png",
  XLARGE: ".thumb.1280.1280.png"
};
const PICTURE_POSITION = {
  DISABLED: "disabled",
  DEFAULT_POSITION: "defaultPosition",
  SECOND_POSITION: "secondPosition"
};
const JEEP_BRAND_ID = 57;
const FIAT_BRAND_ID = 0;
const CHRYSLER_BRAND_ID = 55;
const DODGE_BRAND_ID = 55;
const RAM_BRAND_ID = 58;
const CITROEN_BRAND_ID = 59;
const PEUGEOT_BRAND_ID = 60;
const BRAND = {
  FIAT: "fiat",
  FIAT_FLAG: "fiat-flag",
  FIAT_ABARTH: "fiat-abarth",
  JEEP: "jeep",
  RAM: "ram",
  DODGE: "dodge",
  CHRYSLER: "chrysler",
  CITROEN: "citroen",
  CITROEN2: "citroen-2",
  PEUGEOT: "peugeot"
};
const BRANDS_IDS = {
  [BRAND.JEEP]: JEEP_BRAND_ID,
  [BRAND.FIAT]: FIAT_BRAND_ID,
  [BRAND.DODGE]: DODGE_BRAND_ID,
  [BRAND.RAM]: RAM_BRAND_ID,
  [BRAND.CITROEN]: CITROEN_BRAND_ID,
  [BRAND.CHRYSLER]: CHRYSLER_BRAND_ID,
  [BRAND.PEUGEOT]: PEUGEOT_BRAND_ID
};
const PAGE_BRAND_ID = BRANDS_IDS[`${BRAND[`${PAGE_BRAND == null ? void 0 : PAGE_BRAND.toUpperCase()}`]}`];
const BRANDS_MVS_SUBSTRING = {
  citroen: { modelCodeSize: 4, versionCodeSize: 15, seriesCodeSize: 16 },
  peugeot: { modelCodeSize: 4, versionCodeSize: 15, seriesCodeSize: 16 },
  default: { modelCodeSize: 3, versionCodeSize: 6, seriesCodeSize: 7 },
  ds: { modelCodeSize: 4, versionCodeSize: 15, seriesCodeSize: 16 }
};
const RENTAL_OFFER_AVAILABLE_BRANDS = ["jeep", "fiat", "citroen", "peugeot", "ram"];
const DEFAULT_MVS_CODE = getMetaTagValue("mvs-code");
const DEFAULT_YEAR = getMetaTagValue("year");
const PRICE_SOURCE_TABLE_ECOMMERCE = "ecommercePrice";
const PRICE_SOURCE_TABLE_CUSTOM = "customPrice";
const NMCS_CONSTS = {
  STEPS: {
    ACCESSORIES: "accessories",
    RESUME: "resume",
    SERVICES: "services",
    COLOR: "color",
    VERSION: "version",
    OPTIONALS: "optionals",
    COATING: "coating"
  },
  STEPS_RESERVATION: {
    SHOWCASE: "showcase",
    REGISTER: "register",
    RESERVATION: "reservation",
    PAYMENT: "payment"
  }
};
const FUELS = {
  DIESEL: "Diesel",
  FLEX: "Flex",
  TETRAFUEL: "Tetrafuel",
  ELECTRIC: "Electric",
  HYBRID: "Hybrid",
  GAS: "Gas",
  FLEX_HYBRID: "Flex Hybrid"
};
const FUEL_LABELS = getMetaTagValue("fuel-labels") ? JSON.parse(getMetaTagValue("fuel-labels")) : {};
const CURRENT_CAR_MODELS = getMetaTagValue("current-car-models") ? JSON.parse(getMetaTagValue("current-car-models")) : "";
const PART_BEHAVIOR = {
  OPTIONAL: "OPTIONAL",
  FEATURED: "FEATURED"
};
const PART_TYPE = {
  OPTIONAL: "ITEM",
  ACCESSORY: "ACCESSORY",
  COLOR: "COLOR",
  COATING: "COATING"
};
const RELATED_PRODUCT_TYPE = {
  COLOR: "color",
  OPTIONAL: "optional",
  ACCESSORY: "accessory",
  SERVICE: "service",
  COATING: "coating"
};
const RENTAL_OFFER_TAGS_TYPES = [
  { id: 1, color: "preto" },
  { id: 2, color: "vermelho" },
  { id: 3, color: "amarelo" },
  { id: 4, color: "azul" },
  { id: 5, color: "verde escuro" },
  { id: 6, color: "verde limão" }
];
const COOKIE_DIGITAL_DEALER_NAME = "DDCNPAT";
const COOKIE_LOGIN = {
  WEAK: {
    cookieName: "dd-weak-login-data"
  }
};
const COOKIE_LGPD = "Wisdom_lgpd";
const COOKIE_AUTH = "Wisdom_id_jwt";
const COOKIE_DEFAULT_NAME = "MuchMore_ptc";
const COOKIE_DEFAULT_LABEL = "Protocolo";
const COOKIE_DEALER_CODE = "digitalDealerCode";
const COOKIE_OPEN_CAR_SUMMARY = "open-car-summary";
const COOKIE_USER_ROLES = "Roles";
const COOKIE_LOCATION = "Wisdom_location";
const COOKIE_CAR_SELECTOR = "CAR_SELECTOR";
const COOKIE_RESERVATION_TIMER = "RESERVATION_TIMER";
const COOKIE_ANONYMOUS_USER = "anonymousUserId";
const COOKIE_BONUS_LOVERS = "redirectToBonusLovers";
const COOKIE_GOOGLE_CLIENT_ID = "_ga";
const COOKIE_G_IDENTIFIER = "gclid";
const COOKIE_G_CLIENT_SRC = "gclsrc";
const COOKIE_G_ADS_dc = "_gcl_dc";
const COOKIE_G_ADS_aw = "_gcl_aw";
const COOKIE_G_ADS_c = "_gac_";
const COOKIE_UTM_CAMPAIGN = "utm_campaign";
const COOKIE_UTM_CONTENT = "utm_content";
const COOKIE_UTM_MEDIUM = "utm_medium";
const COOKIE_UTM_SOURCE = "utm_source";
const COOKIE_UTM_TERM = "utm_term";
const DEFAULT_TTL = 144e5;
const LOCATION_TTL = getMetaTagValue("location-ttl") || DEFAULT_TTL;
const RECAPTCHA_KEY = "6LcMH0AhAAAAAHsNeg0DiIQJOpLBws-n8F9byimv";
const SSO_CONTEXT = getMetaTagValue("sso-context");
const SSO_HEADER = "x-hub-dealer-context";
const SSO_HEADER_OFFER = "x-hub-offer-context";
const SSO_HEADER_WORKSTATEMENT = "Hub-Workstatement-Context";
const DEALER_CONTEXT_HEADER = "x-hub-dealer-context";
const TIMEZONE_HEADER = "x-hub-timezone";
const RESERVATION_GUEST_HEADER = "x-hub-reservation-service-anonymous";
const RESERVATION_USER_ID_VALIDATION_HEADER = "x-hub-reservation-service-user-id-validation-header";
const LEADS_ALLOWED_WITHOUT_CPF = getMetaTagValue("leads-allowed-without-cpf") ? JSON.parse(getMetaTagValue("leads-allowed-without-cpf")) : null;
const ENABLES_CPF_CNPJ_IN_LEAD_FORM = getMetaTagValue("enables-cpf-cnpj-in-lead-form") === "true";
const ENABLE_SENDING_OF_LEAD_FOR_CITIES_WITHOUT_INFLUENCE_AREA = getMetaTagValue("enable-sending-lead-for-cities-without-influence-area") === "true";
const LGPD_LEAD_PRIVACY_POLICY = getMetaTagValue("lgpd-lead-privacy-policy");
const PROGRAM_SEARCH_FILTER = getMetaTagValue("program-search-filter") || "";
const NAMESPACE = PROGRAM_SEARCH_FILTER.replace(/\|/g, "/");
const ENABLE_SUBSIDIZED_PRICE = getMetaTagValue("enable-subsidized-price") ? JSON.parse(getMetaTagValue("enable-subsidized-price")) : false;
const DEFAULT_CURRENCY_OPTIONS = {
  locale: "pt",
  currency: null,
  precision: 2,
  distractionFree: false,
  autoDecimalMode: true,
  allowNegative: false
};
const DEFAULT_DATE_VALIDATION_FORMAT = "DD/MM/YYYY";
const DATE_FORMAT = {
  PT_BR: "DD/MM/YYYY",
  EN_US: "YYYY-MM-DD"
};
const MONTHS = [
  "JANEIRO",
  "FEVEREIRO",
  "MARÇO",
  "ABRIL",
  "MAIO",
  "JUNHO",
  "JULHO",
  "AGOSTO",
  "SETEMBRO",
  "OUTUBRO",
  "NOVEMBRO",
  "DEZEMBRO"
];
const DAY_OF_WEEK = {
  SUNDAY: "SUNDAY",
  MONDAY: "MONDAY",
  TUESDAY: "TUESDAY",
  WEDNESDAY: "WEDNESDAY",
  THURSDAY: "THURSDAY",
  FRIDAY: "FRIDAY",
  SATURDAY: "SATURDAY"
};
const CAR_FUNDING_FLOW = {
  FLOW_SELECTION: "flow-selection",
  PAGE_INITIAL_DATA: "page-initial-data",
  INSTALLMENT_CHECK: "installment-check",
  INSTALLMENT_REGISTER: "installment-register",
  INSTALLMENT_TERMS_AND_CONDITIONS: "installment-terms-and-conditions",
  LOADING_PROPOSE_RESULT: "loading-propose-result",
  INSTALLMENT_DENIED: "installment-denied",
  INSTALLMENT_APPROVED: "installment-approved",
  CDC_SIMULATOR: "cdc-simulator",
  NEXT_SIMULATOR: "next-simulator",
  NEXT_LEAD_FORM: "next-lead-form",
  EXTERNAL_FLOW_ERROR: "external-flow-error",
  FUNDING_RESUME: "funding-resume"
};
const FUNDING_SOURCES = {
  ZFLOW: "ZFLOW",
  CDC: "CDC",
  PSA_TRADITIONAL: "PSA_TRADITIONAL",
  NEXT: "NEXT",
  PSA_BALAO: "PSA_BALAO"
};
const FUNDING_LEAD_OBJ_NAME = "leadObj";
const EXTRA_PLANS = ["BALAO", "TRADITIONAL"];
const FUNDING_STATES = {
  TERMS: "terms",
  LEAD_FORM: "lead-form",
  PLANS: "plans",
  PROPOSAL: "proposal",
  COMPARATOR: "comparator",
  ERROR: "error"
};
const FUNDING_PLANS_TYPE = {
  MSC: "MSC",
  ECOM: "ECOM",
  OFFER: "OFFER"
};
const PLAN_CARD_PROPS_DEFAULT = {
  instructionsCtaLabel: "Entenda como funciona",
  legalTextCtaLabel: "Texto legal",
  rebuyManualCtaLabel: "Manual de recompra",
  simulateCtaLabel: "Simule aqui",
  continueCtaLabel: "Continuar",
  orderOnlineCtaLabel: "Encomendar online"
};
const FUNDING_SIMULATOR_DEFAULT = {
  stepsEntrance: 1,
  stepsFinalInstallment: 1
};
const SAVE_SIMULATION_SOURCES = {
  DEFAULT: "default",
  ORDER_ONLINE: "orderOnline"
};
const QR_CODE_PROPERTY = {
  VERSION: {
    MIN: 1,
    MAX: 40
  },
  MASK_PATTERN: {
    MIN: 1,
    MAX: 7
  },
  ELEMENT_TYPE_GENERATOR: {
    SVG: "svg",
    IMG: "img",
    CANVAS: "canvas"
  },
  ERROR_CORRECTION: {
    LOW: "L",
    MEDIUM: "M",
    QUARTILE: "Q",
    HIGH: "H"
  }
};
const PROPOSAL_EVENTS = {
  PROPOSAL_SENT: "PROPOSAL_SENT",
  TEST_DRIVE: "TEST_DRIVE",
  QUOTATION: "QUOTATION"
};
const LOYALTY_PROGRAM = {
  JEEP_NATION: {
    name: "Jeep Nation"
  },
  JEEP: {
    name: "Jeep Wave"
  }
};
const RESTRICT_LIST_LOGIC = {
  WHITELIST: "WHITELIST",
  BLACKLIST: "BLACKLIST"
};
const Geolocation = {
  LAYOUT_TYPE: {
    BOX: "BOX",
    MODAL: "MODAL"
  },
  SELECTOR_STATE: {
    SELECTION: "LOCATION_SELECTION",
    CONFIRMATION: "LOCATION_CONFIRMATION"
  }
};
const SPECIAL_CHARACTER_HASH = {
  â: "a",
  Â: "A",
  à: "a",
  À: "A",
  á: "a",
  Á: "A",
  ã: "a",
  Ã: "A",
  ê: "e",
  Ê: "E",
  è: "e",
  È: "E",
  é: "e",
  É: "E",
  î: "i",
  Î: "I",
  ì: "i",
  Ì: "I",
  í: "i",
  Í: "I",
  õ: "o",
  Õ: "O",
  ô: "o",
  Ô: "O",
  ò: "o",
  Ò: "O",
  ó: "o",
  Ó: "O",
  ü: "u",
  Ü: "U",
  û: "u",
  Û: "U",
  ú: "u",
  Ú: "U",
  ù: "u",
  Ù: "U",
  ç: "c",
  Ç: "C"
};
const HTTP_METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  PATCH: "PATCH",
  DELETE: "DELETE"
};
const TEST_DRIVE_RATINGS = {
  1: "Muito Ruim",
  2: "Ruim",
  3: "Regular",
  4: "Bom",
  5: "Muito Bom"
};
const BENEFIT_REDEEM = {
  SELF: "SELF",
  GIFT: "GIFT",
  GIFTED: "GIFTED"
};
const OFFER_SAMPLE = {
  PRICE_UNAVAILABLE: "Valor indisponível no momento"
};
const RECALL_SERVICE_TYPE = "RECALL";
const RECALL_SERVICE_CODE = "SV03";
const USER_GROUPS = {
  OFFER: "OFFER",
  WCD: "WCD",
  MOPAR: "MOPAR",
  JEEP_NATION: "JEEP_NATION"
};
const USER_ROLES = {
  OFFER: {
    REGIONAL: "REGIONAL",
    NATIONAL: "NATIONAL",
    DEALER_GROUP: "DEALER_GROUP",
    ZONE: "ZONE"
  },
  MOPAR: {
    REGIONAL: "ROLE_REGIONAL",
    ADMIN: "ROLE_ADMIN"
  },
  JEEP_NATION: {
    ADMIN: "ROLE_ADMIN"
  }
};
const USER_CONTACTS = {
  EMAIL: "EMAIL",
  MAILING: "MAILING",
  SMS: "SMS",
  WHATSAPP: "WHATSAPP",
  PHONE: "PHONE",
  getValues: function() {
    const contacts = [];
    Object.entries(USER_CONTACTS).forEach(function([_, value]) {
      if (value.length > 0)
        contacts.push({ "type": value });
    });
    return contacts;
  }
};
const COMPLEMENT_USER_DATE_NATION = {
  STEPS: {
    BASIC_USER_DATA_FORM: "user-data",
    ADDRESS_FORM: "address-data",
    SUCCESS_FORM: "success-message",
    FAVORITE_DEALER_FORM: "dealer-data"
  }
};
const SSO_USER_STATUS = {
  LOADING: "LOADING",
  LOADED: "LOADED"
};
const SSO_ROLE = {
  USER_ADMIN: "user_admin",
  PARTNER_ADMIN: "partner_admin",
  PARTNER_OWNER: "partner_owner",
  REPAIRMAN: "repairman",
  OFFER_ADMIN: "offer_admin",
  CUSTOMER: "customer",
  SALES_CUSTOMER: "sales_customer",
  POST_SALES_CUSTOMER: "post_sales_customer",
  GAME_ADMIN: "game_admin",
  MANUAL_ADMIN: "manual_admin",
  GAME_MODERATOR: "game_moderator",
  GAME_PLAYER: "game_player",
  PROCEDURE_MANAGER: "procedure_manager",
  REGIONAL_MANAGER: "regional_manager",
  DEALER_MANAGER: "dealer_manager",
  INSPECTOR: "inspector",
  USER_DEALER: "user_dealer",
  EXTERNAL_APPLICATION_ADMIN: "external_application_admin",
  DEALER_BLOCKER: "dealer_blocker",
  QRCODE_GENERATOR: "qr_code_generator",
  EXTERNAL_APPLICATION_USER: "external_application_user",
  SERVICE_ADMIN: "service_admin",
  DMS: "dms",
  EVENT_ADMIN: "event_admin",
  LEAD_QUEUE_MANAGER: "lead_queue_manager",
  USER_CREATOR: "user_creator",
  CACHE_MANAGER: "cache_manager",
  INTEGRATION_ERROR_MANAGER: "integration_error_manager",
  PUSH_NOTIFICATION_ADMIN: "push_notification_admin",
  SUBSCRIPTION_PAYMENT_MANAGER: "subscription_payment_manager",
  TOLL_EVENT_MANAGER: "toll_event_manager",
  FOOD_CATALOG_MANAGER: "food_catalog_manager",
  VOUCHER_ADMIN: "voucher_admin"
};
const SSO_VALID_BRANDS = ["fiat", "jeep", "dodge", "chrysler", "ram", "citroen"];
const SSO_MARKET = {
  C_BR: "c-BR",
  PT_BR: "pt-BR",
  ES_AR: "es-AR"
};
const tabTitles = {
  [SSO_ROLE.USER_ADMIN]: {
    [SSO_MARKET.C_BR]: "Administrador de Usuários",
    [SSO_MARKET.PT_BR]: "Administrador de Usuários"
  },
  [SSO_ROLE.PARTNER_ADMIN]: {
    [SSO_MARKET.C_BR]: "Administrador de Parceiros"
  },
  [SSO_ROLE.PARTNER_OWNER]: {
    [SSO_MARKET.C_BR]: "Owner de Parceiros"
  },
  [SSO_ROLE.REPAIRMAN]: {
    [SSO_MARKET.PT_BR]: "Reparador"
  },
  [SSO_ROLE.OFFER_ADMIN]: {
    [SSO_MARKET.PT_BR]: "Ofertas",
    [SSO_MARKET.ES_AR]: "Ofertas Argentina"
  },
  [SSO_ROLE.CUSTOMER]: {
    [SSO_MARKET.PT_BR]: "Cliente"
  },
  [SSO_ROLE.SALES_CUSTOMER]: {
    [SSO_MARKET.PT_BR]: "Cliente"
  },
  [SSO_ROLE.POST_SALES_CUSTOMER]: {
    [SSO_MARKET.PT_BR]: "Cliente Pós-venda"
  },
  [SSO_ROLE.GAME_ADMIN]: {
    [SSO_MARKET.PT_BR]: "Administrador"
  },
  [SSO_ROLE.MANUAL_ADMIN]: {
    [SSO_MARKET.PT_BR]: "Administrador de Manuais",
    [SSO_MARKET.ES_AR]: "Administrador de Manuais Argentina"
  },
  [SSO_ROLE.GAME_MODERATOR]: {
    [SSO_MARKET.PT_BR]: "Moderador"
  },
  [SSO_ROLE.GAME_PLAYER]: {
    [SSO_MARKET.PT_BR]: "Jogador"
  },
  [SSO_ROLE.PROCEDURE_MANAGER]: {
    [SSO_MARKET.PT_BR]: "Gestor de Procedimento"
  },
  [SSO_ROLE.REGIONAL_MANAGER]: {
    [SSO_MARKET.PT_BR]: "Gestor Regional"
  },
  [SSO_ROLE.DEALER_MANAGER]: {
    [SSO_MARKET.PT_BR]: "Gerente de Dealer"
  },
  [SSO_ROLE.INSPECTOR]: {
    [SSO_MARKET.PT_BR]: "Inspetor"
  },
  [SSO_ROLE.USER_DEALER]: {
    [SSO_MARKET.PT_BR]: "Concessionária Digital",
    [SSO_MARKET.ES_AR]: "Concessionária Digital Argentina"
  },
  [SSO_ROLE.EXTERNAL_APPLICATION_ADMIN]: {
    [SSO_MARKET.C_BR]: "Administrador de Aplicações Externas",
    [SSO_MARKET.PT_BR]: "Administrador de Aplicações Externas"
  },
  [SSO_ROLE.DEALER_BLOCKER]: {
    [SSO_MARKET.PT_BR]: "Bloqueador de Concessionárias"
  },
  [SSO_ROLE.QRCODE_GENERATOR]: {
    [SSO_MARKET.C_BR]: "Gerador de QR Code",
    [SSO_MARKET.PT_BR]: "Gerador de QR Code"
  },
  [SSO_ROLE.EXTERNAL_APPLICATION_USER]: {
    [SSO_MARKET.C_BR]: "Aplicações Externas",
    [SSO_MARKET.PT_BR]: "Aplicações Externas"
  },
  [SSO_ROLE.SERVICE_ADMIN]: {
    [SSO_MARKET.PT_BR]: "Administrador de Serviços",
    [SSO_MARKET.ES_AR]: "Administrador de Serviços Argentina"
  },
  [SSO_ROLE.DMS]: {
    [SSO_MARKET.PT_BR]: "DMS"
  },
  [SSO_ROLE.EVENT_ADMIN]: {
    [SSO_MARKET.PT_BR]: "Administrador de Eventos"
  },
  [SSO_ROLE.LEAD_QUEUE_MANAGER]: {
    [SSO_MARKET.PT_BR]: "Administrador da Fila de Leads"
  },
  [SSO_ROLE.USER_CREATOR]: {
    [SSO_MARKET.C_BR]: "Criador de Usuários",
    [SSO_MARKET.PT_BR]: "Criador de Usuários"
  },
  [SSO_ROLE.CACHE_MANAGER]: {
    [SSO_MARKET.PT_BR]: "Gestor de Cache"
  },
  [SSO_ROLE.INTEGRATION_ERROR_MANAGER]: {
    [SSO_MARKET.PT_BR]: "Gestor de Erros de Integração"
  },
  [SSO_ROLE.PUSH_NOTIFICATION_ADMIN]: {
    [SSO_MARKET.PT_BR]: "Administrador de Notificações Push"
  },
  [SSO_ROLE.SUBSCRIPTION_PAYMENT_MANAGER]: {
    [SSO_MARKET.PT_BR]: "Gestor de pagamentos recorrentes"
  },
  [SSO_ROLE.TOLL_EVENT_MANAGER]: {
    [SSO_MARKET.PT_BR]: "Gestor de eventos de pedágio e cancela"
  },
  [SSO_ROLE.FOOD_CATALOG_MANAGER]: {
    [SSO_MARKET.PT_BR]: "Gestor do catálogo cart"
  },
  [SSO_ROLE.VOUCHER_ADMIN]: {
    [SSO_MARKET.PT_BR]: "Administrador de Voucher"
  }
};
const CONTEXTS_MAP = {
  entregaimpecavel: "Entrega impecável",
  digitaldealership: "Concessionária digital"
};
const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  PARTIAL_CONTENT: 206,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_ERROR: 500,
  UNPROCESSABLE_ENTITY: 422,
  CONFLICT: 409
};
const PROMISE_STATUS = {
  PENDING: "pending",
  REJECTED: "rejected",
  FULFILLED: "fulfilled"
};
const RENTAL_PROPOSAL_TIMELINE_STATUS = {
  PROPOSAL_CREATED: "PROPOSAL_CREATED",
  FINANCIAL_ANALYSIS_IN_PROGRESS: "FINANCIAL_ANALYSIS_IN_PROGRESS",
  FINANCIAL_ANALYSIS_APPROVED: "FINANCIAL_ANALYSIS_APPROVED",
  FINANCIAL_ANALYSIS_REPROVED: "FINANCIAL_ANALYSIS_REPROVED",
  CONTRACT_SIGN_IN_PROGRESS: "CONTRACT_SIGN_IN_PROGRESS",
  CONTRACT_SIGN_DONE: "CONTRACT_SIGN_DONE",
  PRODUCTION_REQUESTED: "PRODUCTION_REQUESTED",
  IN_PRODUCTION: "IN_PRODUCTION",
  IN_TRANSIT: "IN_TRANSIT",
  AT_DEALER: "AT_DEALER",
  DELIVERED: "DELIVERED",
  EXPIRED_PROPOSAL: "EXPIRED_PROPOSAL"
};
const STATS_VISIT_SCHEDULE = {
  A: { value: "A", label: "Confirmada", className: "visit-confirmeted" },
  C: { value: "C", label: "Cancelada", className: "visit-canceled" },
  P: { value: "P", label: "Pendente", className: "wating-confirmation" },
  R: { value: "R", label: "Reprovado", className: "" },
  B: { value: "B", label: "Bloqueado", className: "" }
};
const RESERVATION_TIMELINE_STATUS = {
  CREATED: "CREATED",
  UPLOADED_DOCS: "UPLOADED_DOCS",
  WAITING_DOCS: "WAITING_DOCS",
  CONTRACT_SIGN_DONE: "CONTRACT_SIGN_DONE",
  ASSEMBLY: "ASSEMBLY",
  INVOICE_DELIVERY: "INVOICE_DELIVERY",
  IN_TRANSIT: "IN_TRANSIT",
  AT_DEALER: "AT_DEALER",
  DELIVERED: "DELIVERED",
  IN_NATIONAL_TERRITORY: "IN_NATIONAL_TERRITORY",
  CANCELLED: "CANCELLED",
  ORDER_MADE: "ORDER_MADE",
  APPROVED_RESERVATION: "APPROVED_RESERVATION",
  REVENUE: "REVENUE",
  TRANSIT: "TRANSIT",
  DELIVERED_RESERVATION: "DELIVERED_RESERVATION"
};
const NEW_RESERVATION_TIMELINE_STATUS = {
  // Operational
  PRE_RESERVE: "PRE_RESERVE",
  RESERVE: "RESERVE",
  BILLET_PAYMENT: "BILLET_PAYMENT",
  FINANCING_PAYMENT: "FINANCING_PAYMENT",
  DEALER_PAYMENT: "DEALER_PAYMENT",
  UPLOADED_DOCS: "UPLOADED_DOCS",
  ANTIFRAUD: "ANTI_FRAUD",
  IN_APPROVAL_VD: "APPROVAL_DIRECT_SALE",
  WAITING_LIST: "WAITING_LIST",
  IN_APPROVAL_CLIENT: "APPROVAL_EMPLOYEE",
  SIGN_CONTRACT: "SIGN_CONTRACT",
  CREATED_ORDER: "CREATED_ORDER",
  MOUNTED_VEHICLE: "MOUNTED_VEHICLE",
  VEHICLE_PRODUCED: "VEHICLE_PRODUCED",
  INVOICED: "INVOICED",
  BILLET_AVAILABLE: "BILLET_AVAILABLE",
  EXPEDITE: "EXPEDITE",
  DELIVER_TO_CCSS: "DELIVER_TO_CCSS",
  CUSTOMER_DELIVERY: "CUSTOMER_DELIVERY",
  BILLING: "BILLING",
  REGISTERED: "REGISTERED",
  TRANSPORTING: "TRANSPORTING",
  REMAINING_PAYMENT: "REMAINING_PAYMENT",
  PAID: "PAID",
  IN_TRANSIT: "IN_TRANSIT",
  AT_DEALER: "AT_DEALER",
  CANCELLED: "CANCELLED",
  DELIVERED: "DELIVERED",
  REQUESTED_CANCELLATION: "REQUESTED_CANCELLATION",
  REACTIVATED_ORDER: "REACTIVATED_ORDER",
  PROGRESS_ORDER: "PROGRESS_ORDER",
  INVOICE_DELIVERY: "INVOICE_DELIVERY",
  EXT_CONSORTIUM_PAYMENT: "EXT_CONSORTIUM_PAYMENT",
  FIAT_CONSORTIUM_PAYMENT: "FIAT_CONSORTIUM_PAYMENT",
  PLACED: "PLACED",
  //Funding
  PROPOSAL_SENT: "PROPOSAL_SENT",
  PROGRESS_PROPOSAL: "PROGRESS_PROPOSAL",
  REANALYSIS_PROPOSAL: "REANALYSIS_PROPOSAL",
  PENDING_PROPOSAL: "PENDING_PROPOSAL",
  APPROVED_PROPOSAL: "APPROVED_PROPOSAL",
  RELEASED_PROPOSAL: "RELEASED_PROPOSAL",
  INTEGRATED_PROPOSAL: "INTEGRATED_PROPOSAL",
  DIRECTED_PROPOSAL: "DIRECTED_PROPOSAL",
  DENIED_PROPOSAL: "DENIED_PROPOSAL",
  APPROVED_FRAUD: "APPROVED_FRAUD",
  FORMALIZATION: "FORMALIZATION",
  DOCUMENT_ANALYSIS: "DOCUMENT_ANALYSIS",
  PENDING_DOCUMENT: "PENDING_DOCUMENT",
  PAYMENT_AVAILABLE: "PAYMENT_AVAILABLE",
  PENDING_REGISTER_INFO: "PENDING_REGISTER_INFO",
  PENDING_CONTRACT_SIGN: "PENDING_CONTRACT_SIGN",
  PAYED_PROPOSAL: "PAYED_PROPOSAL",
  PENDING_CONTRACT_DISCHARGE: "PENDING_CONTRACT_DISCHARGE",
  PENDING_TAX_DISCHARGE: "PENDING_TAX_DISCHARGE",
  WARRANTY_ANALYSIS: "WARRANTY_ANALYSIS",
  PAYMENT_ON_RELEASE: "PAYMENT_ON_RELEASE",
  PAYMENT_ERROR: "PAYMENT_ERROR",
  PAYMENT_DONE: "PAYMENT_DONE",
  WAITING_INTEGRATION: "WAITING_INTEGRATION",
  PROPOSAL_FORMALIZATION: "PROPOSAL_FORMALIZATION"
};
const TEST_DRIVE_STATUS = {
  REQUESTED: "REQUESTED",
  CONFIRMED: "CONFIRMED",
  DONE: "DONE",
  CANCELLED: "CANCELLED",
  EXPIRED: "EXPIRED"
};
const DATALOADER_STATUS = {
  PROCESSING: "PROCESSING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED"
};
const PROCEDURE_STATUS = {
  IN_PROGRESS: "IN_PROGRESS",
  SUBMITTED: "SUBMITTED"
};
const ENABLE_CHATBOT = getMetaTagValue("enable-chat-bot") === "true";
const FACEBOOK_APP_ID = getMetaTagValue("facebook-app-id");
const USER_DATA_SALESFORCE_INTEGRATION = getMetaTagValue("user-data-salesforce-integration");
const USER_GARAGE_INTEGRATION = {
  FCA_ID: "fca_id",
  FCA_ID_PLUS_SALESFORCE: "fca_id_plus_salesforce",
  SALESFORCE: "salesforce"
};
const GOOGLE_MAPS_DIR_API = "https://www.google.com/maps/dir/?api=1";
const GOOGLE_APP_ID = getMetaTagValue("google-app-id");
const GA_PRODUCT = getMetaTagValue("google-analytics-product");
const GA_SEGMENT = getMetaTagValue("google-analytics-segment");
const GA_TRACK_ID = getMetaTagValue("gatrackid");
const DISABLE_APPSTATE_MUTATIONS = getMetaTagValue("disable-appstate-mutations");
const COGNITO_USER_POOL_ID = getMetaTagValue("cognito-user-pool-id");
const COGNITO_APP_CLIENT_ID = getMetaTagValue("cognito-app-client-id");
const COGNITO_REGION = getMetaTagValue("cognito-region");
const COGNITO_IDENTITY_POOL_ID = getMetaTagValue("cognito-identity-pool-id");
const DEVICE_TYPE = {
  MOBILE: "mobile",
  TABLET: "tablet",
  DESKTOP: "desktop"
};
const CONFIRMATION_POPUP_TYPE = {
  DEFAULT: "DEFAULT",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  INFO: "INFO",
  WARNING: "WARNING"
};
const MESSAGE_POPUP_TYPE = {
  ERROR: "ERROR",
  SUCCESS: "SUCCESS",
  WARNING: "WARNING",
  CUSTOM: "CUSTOM"
};
const RESERVATION_TYPE = {
  FOCUS: "focus",
  OFFLINE: "offline",
  LABELED: "labeled",
  LEAD_OFFLINE: "leadOffline"
};
const SUPPORTED_ENCODE_TYPE = {
  BASE_64: "BASE64",
  URI: "URI"
};
const RESPONSE_DOMAIN_TYPES = {
  TEXT: "TEXT",
  SINGLE: "SINGLE",
  EVIDENCE: "EVIDENCE",
  DATEPICKER: "DATEPICKER",
  EMAIL: "EMAIL",
  PHONE_NUMBER: "PHONE_NUMBER",
  LOYALTY_PROGRAMS: "LOYALTY_PROGRAMS"
};
const PAYMENT_TYPES = {
  FULL_PRICE: "FULL_PRICE",
  STARTS_WITH: "STARTS_WITH",
  FROM_TO: "FROM_TO",
  PERCENT: "PERCENT",
  INSTALLMENT: "INSTALLMENT"
};
const OFFER_TYPE = {
  FCA: "FCA",
  DEALER: "DEALER",
  RENTAL: "RENTAL"
};
const MOPAR_OFFER_TYPE = {
  SERVICE: "SERVICE",
  ACCESSORY: "ACCESSORY"
};
const MOPAR_OFFER_TYPES = {
  COUPON: "COUPON",
  FIXED_PRICE: "FIXED_PRICE"
};
const DEALER_TYPE = {
  ONLINE_SCHEDULE: "ONLINE_SCHEDULE",
  DIGITAL_DEALER: "DIGITAL_DEALER"
};
const DEALER_PERIOD_TYPE = {
  WORKING_TIME: "WORKING_TIME",
  BREAK: "BREAK"
};
const COVERAGE_TYPES = {
  NATIONAL: "NATIONAL",
  STATE: "STATE",
  REGIONAL: "REGIONAL",
  DEALER_GROUP: "DEALER_GROUP"
};
const JURISDICTION_TYPE = {
  MARKET: "MARKET",
  CONTEXT: "CONTEXT",
  BRAND: "BRAND",
  DEALER_GROUP: "DEALER_GROUP",
  DEALER: "DEALER"
};
const HTML_TAGS_TYPE = {
  "font-h1": "h1",
  "font-h2": "h2",
  "font-h3": "h3",
  "font-body": "p",
  "font-body-sm": "span",
  "font-link": "a",
  "font-link-sm": "a",
  "font-label": "label"
};
const NEW_RESERVATION_FUNDING_TYPE = {
  PSA: "PSA",
  B2: "B2"
};
const AUTH_SERVICE_URL = getMetaTagValue("auth-service-url");
const B2E_SERVICE_URL = getMetaTagValue("b2e-service-url");
const B2E_SEARCH_URL = getMetaTagValue("b2e-search-url");
const CAR_SERVICE_URL = getMetaTagValue("car-service-url");
const CONFIAT_SERVICE_URL = getMetaTagValue("confiat-service-url");
const CONTACT_US_SERVICE_URL = getMetaTagValue("contact-us-service-url");
const DEALER_SALES_SERVICE_URL = getMetaTagValue("dealer-sales-service-url");
const DEALER_SCHEDULER_SERVICE_URL = getMetaTagValue("dealerscheduler-service-url");
const DEALER_SERVICE_URL = getMetaTagValue("dealer-service-url");
const DICTIONARY_SERVICE_URL = getMetaTagValue("dictionary-service-url");
const DOCUMENT_UPLOADER_SERVICE_URL = getMetaTagValue("document-uploader-service-url");
const EVALUATE_SERVICE_URL = getMetaTagValue("evaluate-service-url");
const EVENT_CONTEXT_AWS_URL = getMetaTagValue("event-context-aws-url");
const EVENTS_SERVICE_URL = getMetaTagValue("event-service-url");
const FACE_IDENTITY_SERVICE_URL = getMetaTagValue("face-identity-service-url");
const FCA_BMC_API_URL = getMetaTagValue("fca-bmc-api-url");
const FINANCING_SERVICE_URL = getMetaTagValue("financing-service-url");
const FINANCING_HUB_SERVICE_URL = getMetaTagValue("financing-hub-service-url");
const GAME_SERVICE_URL = getMetaTagValue("game-service-url");
const GARAGE_SERVICE_URL = getMetaTagValue("garage-service-url");
const IDENTITY_VALIDATION_SERVICE_URL = getMetaTagValue("identity-validation-service");
const INTEGRATION_LOG_SERVICE_URL = getMetaTagValue("integrationlog-service-url");
const JOURNEY_SERVICE_URL = getMetaTagValue("journey-service-url");
const LEAD_INTEGRATION_URL_V2 = getMetaTagValue("lead-integration-url-v2");
const LOCATION_SERVICE_URL = getMetaTagValue("location-service-url");
const LOYALTY_SERVICE_URL = getMetaTagValue("loyalty-service-url");
const MAINTENENCE_SERVICE_URL = getMetaTagValue("maintenance-service-url");
const MANUAL_SERVICE_URL = getMetaTagValue("manual-service-url");
const MODELS_URL = getMetaTagValue("models-url") ? JSON.parse(getMetaTagValue("models-url")) : "";
const MOPAR_SERVICE_URL = getMetaTagValue("mopar-service-url");
const MOPAROFFER_SERVICE_URL = getMetaTagValue("moparoffer-service-url");
const MVS_SERVICE_URL = getMetaTagValue("mvs-service-url");
const OFFER_ADMIN_SERVICE_URL = getMetaTagValue("offer-admin-service-url");
const OFFER_SITE_URL = getMetaTagValue("offer-site-url");
const PART_SERVICE_URL = getMetaTagValue("part-service-url");
const PRICE_SERVICE_URL = getMetaTagValue("price-service-url");
const PROCEDURE_SERVICE_URL = getMetaTagValue("procedure-service-url");
const RATING_SERVICE_URL = getMetaTagValue("rating-service-url");
const RECALL_SERVICE_URL = getMetaTagValue("recall-service-url");
const RENTAL_OFFER_SERVICE_URL = getMetaTagValue("rental-offer-service-url");
const RESERVATION_SERVICE_URL = getMetaTagValue("reservation-service-url");
const SEARCH_RESPONSE_DOMAINS_URL = getMetaTagValue("search-response-domains-url");
const SSO_PARTNER_SERVICE_URL = getMetaTagValue("sso-partner-service-url");
const STOCK_SERVICE_URL = getMetaTagValue("stock-service-url");
const USER_ANALYTICS_SERVICE_URL = getMetaTagValue("user-analytics-service-url");
const USER_SERVICE_URL = getMetaTagValue("user-service-url");
const VISIT_SCHEDULE_URL = getMetaTagValue("visitant-schedule-url");
const VISIT_SCHEDULING_SERVICE_URL = getMetaTagValue("visit-scheduling-service-url");
const VOUCHER_HUB_SERVICE_URL = getMetaTagValue("voucher-hub-service-url");
const WHATSAPP_API_URL = getMetaTagValue("whatsapp-api-url");
const QUIZ_SERVICE_URL = getMetaTagValue("quiz-service-url");
const VERSION_COMPARATOR_URL = getMetaTagValue("version-comparator-service-url");
const RENTAL_USER_SERVICE_URL = getMetaTagValue("rental-user-service-url");
const BENEFITS_SERVICE_URL = getMetaTagValue("benefits-service-url");
const BENEFITS_SERVICE_HUB_URL = getMetaTagValue("benefits-service-hub-url");
const NEW_OFFER_SEARCH_URL = getMetaTagValue("new-offer-search-url");
const PAYMENT_SECURITY_SERVICE_URL = getMetaTagValue("payment-security-service-url");
const TRANSACTION_PAGADOR_URL = getMetaTagValue("transaction-pagador-url");
const LOYALTY_SUBSCRIPTION_SERVICE_URL = getMetaTagValue("loyalty-subscription-service-url");
const ORG_ID = getMetaTagValue("org-id");
const PROMOTION_SERVICE_URL = getMetaTagValue("promotion-service-url");
const CPF_WITH_MASK_LENGTH = 14;
const CPF_WITHOUT_MASK_LENGTH = 11;
const CNPJ_WITH_MASK_LENGTH = 18;
const CNPJ_WITHOUT_MASK_LENGTH = 14;
const MARITAL_STATUS = {
  SINGLE: "Solteiro(a)",
  MARRIED: "Casado(a)",
  DIVORCED: "Divorciado(a)",
  WIDOWED: "Viúvo(a)",
  STABLE_UNION: "União Estável"
};
const FORM_ORIGIN = {
  LEAD_FORM: "leadform"
};
const AFTER_SALES_LEAD_TYPE = "Serviços e acessórios";
const CONTACT_TYPE = {
  EMAIL: "EMAIL",
  MAILING: "MAILING",
  SMS: "SMS",
  WHATSAPP: "WHATSAPP",
  PHONE: "PHONE",
  getTypes: () => Object.values(CONTACT_TYPE).filter((value) => typeof value === "string").map((value) => ({ type: value }))
};
const IDENTITY_VALIDATION_STEPS = {
  VALIDATING_IDENTITY: "VALIDATING_IDENTITY",
  VALIDATING_TOKEN: "VALIDATING_TOKEN",
  AWAITING_INOVAMIND: "AWAITING_INOVAMIND",
  AWAITING_QUIZ: "AWAITING_QUIZ",
  SYNC_SALESFORCE: "SYNC_SALESFORCE",
  PERSISTED_ON_HUB: "PERSISTED_ON_HUB"
};
const DRIVER_LICENSE_CATEGORIES = ["AB", "A", "B", "C", "D", "E"];
const PHYSICAL_PERSON = "physicalPerson";
const LEGAL_PERSON = "legalPerson";
const OCCUPATION_LIST = [
  "Aposentado",
  "Assalariado",
  "Autônomo",
  "Empresário/Sócio proprietário",
  "Funcionário público",
  "Militar",
  "Outros",
  "Pensionista",
  "Profissional Liberal"
];
const VISITORS_LOCATION_COORDINATES = "VISITORS_LOCATION_COORDINATES";
const VISITORS_LOCATION_INFO = "VISITORS_LOCATION_INFO";
export {
  ACCESSORY_ASSETS_BRAND_PATH,
  ACCESSORY_ASSETS_MOPAR_PATH,
  ACCESSORY_ASSETS_PATH,
  ACCESSORY_ASSETS_SOURCE_PATH_LOGIC_VALUES,
  AFTER_SALES_LEAD_TYPE,
  ANCHOR_ANIMATION_DELAY,
  ANCHOR_ANIMATION_OFFSET_TOP,
  AUTH_SERVICE_URL,
  B2E_SEARCH_URL,
  B2E_SERVICE_URL,
  BENEFITS_SERVICE_HUB_URL,
  BENEFITS_SERVICE_URL,
  BENEFIT_REDEEM,
  BRAND,
  BRANDS_IDS,
  BRANDS_MVS_SUBSTRING,
  BRAND_DAM_PATH,
  BRAND_MOPAR_DAM_PATH,
  BRAND_PATH,
  CAR_FUNDING_FLOW,
  CAR_SERVICE_URL,
  CHRYSLER_BRAND_ID,
  CITROEN_BRAND_ID,
  CNPJ_WITHOUT_MASK_LENGTH,
  CNPJ_WITH_MASK_LENGTH,
  COGNITO_APP_CLIENT_ID,
  COGNITO_IDENTITY_POOL_ID,
  COGNITO_REGION,
  COGNITO_USER_POOL_ID,
  COMPLEMENT_USER_DATE_NATION,
  CONFIAT_SERVICE_URL,
  CONFIRMATION_POPUP_TYPE,
  CONTACT_TYPE,
  CONTACT_US_SERVICE_URL,
  CONTEXTS_MAP,
  COOKIE_ANONYMOUS_USER,
  COOKIE_AUTH,
  COOKIE_BONUS_LOVERS,
  COOKIE_CAR_SELECTOR,
  COOKIE_DEALER_CODE,
  COOKIE_DEFAULT_LABEL,
  COOKIE_DEFAULT_NAME,
  COOKIE_DIGITAL_DEALER_NAME,
  COOKIE_GOOGLE_CLIENT_ID,
  COOKIE_G_ADS_aw,
  COOKIE_G_ADS_c,
  COOKIE_G_ADS_dc,
  COOKIE_G_CLIENT_SRC,
  COOKIE_G_IDENTIFIER,
  COOKIE_LGPD,
  COOKIE_LOCATION,
  COOKIE_LOGIN,
  COOKIE_OPEN_CAR_SUMMARY,
  COOKIE_RESERVATION_TIMER,
  COOKIE_USER_ROLES,
  COOKIE_UTM_CAMPAIGN,
  COOKIE_UTM_CONTENT,
  COOKIE_UTM_MEDIUM,
  COOKIE_UTM_SOURCE,
  COOKIE_UTM_TERM,
  COVERAGE_TYPES,
  CPF_WITHOUT_MASK_LENGTH,
  CPF_WITH_MASK_LENGTH,
  CURRENT_CAR_MODELS,
  DATALOADER_STATUS,
  DATE_FORMAT,
  DAY_OF_WEEK,
  DEALER_CONTEXT_HEADER,
  DEALER_PERIOD_TYPE,
  DEALER_SALES_SERVICE_URL,
  DEALER_SCHEDULER_SERVICE_URL,
  DEALER_SERVICE_URL,
  DEALER_TYPE,
  DEFAULT_CURRENCY_OPTIONS,
  DEFAULT_DATE_VALIDATION_FORMAT,
  DEFAULT_MVS_CODE,
  DEFAULT_TTL,
  DEFAULT_YEAR,
  DEVICE_TYPE,
  DICTIONARY_SERVICE_URL,
  DISABLE_APPSTATE_MUTATIONS,
  DOCUMENT_UPLOADER_SERVICE_URL,
  DODGE_BRAND_ID,
  DRIVER_LICENSE_CATEGORIES,
  ENABLES_CPF_CNPJ_IN_LEAD_FORM,
  ENABLE_CHATBOT,
  ENABLE_SENDING_OF_LEAD_FOR_CITIES_WITHOUT_INFLUENCE_AREA,
  ENABLE_SUBSIDIZED_PRICE,
  EVALUATE_SERVICE_URL,
  EVENTS_SERVICE_URL,
  EVENT_CONTEXT_AWS_URL,
  EXTRA_PLANS,
  FACEBOOK_APP_ID,
  FACE_IDENTITY_SERVICE_URL,
  FALLBACK_CAR_IMAGE,
  FCA_BMC_API_URL,
  FIAT_BRAND_ID,
  FINANCING_HUB_SERVICE_URL,
  FINANCING_SERVICE_URL,
  FORM_ORIGIN,
  FUELS,
  FUEL_LABELS,
  FUNDING_LEAD_OBJ_NAME,
  FUNDING_PLANS_TYPE,
  FUNDING_SIMULATOR_DEFAULT,
  FUNDING_SOURCES,
  FUNDING_STATES,
  GAME_SERVICE_URL,
  GARAGE_SERVICE_URL,
  GA_PRODUCT,
  GA_SEGMENT,
  GA_TRACK_ID,
  GOOGLE_APP_ID,
  GOOGLE_MAPS_DIR_API,
  Geolocation,
  HTML_TAGS_TYPE,
  HTTP_METHODS,
  HTTP_STATUS,
  IDENTITY_VALIDATION_SERVICE_URL,
  IDENTITY_VALIDATION_STEPS,
  IMAGE_360_MODE,
  INTEGRATION_LOG_SERVICE_URL,
  JEEP_BRAND_ID,
  JOURNEY_SERVICE_URL,
  JURISDICTION_TYPE,
  LEADS_ALLOWED_WITHOUT_CPF,
  LEAD_INTEGRATION_URL_V2,
  LEGAL_PERSON,
  LGPD_LEAD_PRIVACY_POLICY,
  LOCATION_SERVICE_URL,
  LOCATION_TTL,
  LOYALTY_PROGRAM,
  LOYALTY_SERVICE_URL,
  LOYALTY_SUBSCRIPTION_SERVICE_URL,
  MAINTENENCE_SERVICE_URL,
  MANUAL_SERVICE_URL,
  MARITAL_STATUS,
  MESSAGE_POPUP_TYPE,
  MODELS_URL,
  MONTHS,
  MOPAROFFER_SERVICE_URL,
  MOPAR_DAM_PATH,
  MOPAR_OFFER_TYPE,
  MOPAR_OFFER_TYPES,
  MOPAR_PATH,
  MOPAR_SERVICE_URL,
  MVS_SERVICE_URL,
  NAMESPACE,
  NEW_OFFER_SEARCH_URL,
  NEW_RESERVATION_FUNDING_TYPE,
  NEW_RESERVATION_TIMELINE_STATUS,
  NMCS_CONSTS,
  OCCUPATION_LIST,
  OFFER_ADMIN_SERVICE_URL,
  OFFER_SAMPLE,
  OFFER_SITE_URL,
  OFFER_TYPE,
  ORG_ID,
  PAGE_BRAND,
  PAGE_BRAND_ID,
  PAGE_CONTEXT,
  PAGE_COUNTRY,
  PAGE_COUNTRY_PHONE_CODE,
  PAGE_COUNTRY_TITLE,
  PAGE_LANGUAGE,
  PAGE_MARKET,
  PAGE_SKIN,
  PART_BEHAVIOR,
  PART_SERVICE_URL,
  PART_TYPE,
  PAYMENT_SECURITY_SERVICE_URL,
  PAYMENT_TYPES,
  PEUGEOT_BRAND_ID,
  PHYSICAL_PERSON,
  PICTURE_POSITION,
  PLAN_CARD_PROPS_DEFAULT,
  PRICE_SERVICE_URL,
  PRICE_SOURCE_TABLE_CUSTOM,
  PRICE_SOURCE_TABLE_ECOMMERCE,
  PROCEDURE_SERVICE_URL,
  PROCEDURE_STATUS,
  PROGRAM_SEARCH_FILTER,
  PROMISE_STATUS,
  PROMOTION_SERVICE_URL,
  PROPOSAL_EVENTS,
  QR_CODE_PROPERTY,
  QUIZ_SERVICE_URL,
  RAM_BRAND_ID,
  RATING_SERVICE_URL,
  RECALL_SERVICE_CODE,
  RECALL_SERVICE_TYPE,
  RECALL_SERVICE_URL,
  RECAPTCHA_KEY,
  RELATED_PRODUCT_TYPE,
  RENDITIONS_PATH,
  RENDITIONS_SIZE,
  RENTAL_OFFER_AVAILABLE_BRANDS,
  RENTAL_OFFER_SERVICE_URL,
  RENTAL_OFFER_TAGS_TYPES,
  RENTAL_PROPOSAL_TIMELINE_STATUS,
  RENTAL_USER_SERVICE_URL,
  RESERVATION_GUEST_HEADER,
  RESERVATION_SERVICE_URL,
  RESERVATION_TIMELINE_STATUS,
  RESERVATION_TYPE,
  RESERVATION_USER_ID_VALIDATION_HEADER,
  RESPONSE_DOMAIN_TYPES,
  RESTRICT_LIST_LOGIC,
  SAVE_SIMULATION_SOURCES,
  SEARCH_RESPONSE_DOMAINS_URL,
  SPECIAL_CHARACTER_HASH,
  SSO_CONTEXT,
  SSO_HEADER,
  SSO_HEADER_OFFER,
  SSO_HEADER_WORKSTATEMENT,
  SSO_MARKET,
  SSO_PARTNER_SERVICE_URL,
  SSO_ROLE,
  SSO_USER_STATUS,
  SSO_VALID_BRANDS,
  STATS_VISIT_SCHEDULE,
  STOCK_SERVICE_URL,
  SUPPORTED_ENCODE_TYPE,
  TEST_DRIVE_RATINGS,
  TEST_DRIVE_STATUS,
  TIMEZONE_HEADER,
  TRANSACTION_PAGADOR_URL,
  USER_ANALYTICS_SERVICE_URL,
  USER_CONTACTS,
  USER_DATA_SALESFORCE_INTEGRATION,
  USER_GARAGE_INTEGRATION,
  USER_GROUPS,
  USER_ROLES,
  USER_SERVICE_URL,
  VERSION_COMPARATOR_URL,
  VISITORS_LOCATION_COORDINATES,
  VISITORS_LOCATION_INFO,
  VISIT_SCHEDULE_URL,
  VISIT_SCHEDULING_SERVICE_URL,
  VOUCHER_HUB_SERVICE_URL,
  WHATSAPP_API_URL,
  tabTitles
};
